import { Button } from "components/DesignSystem/Button/Button";
import Modal from "components/DesignSystem/Modal/Modal";
import { ModalProps } from "types/utils/modal";

export const DeleteField = ({
  isOpen,
  close,
  onDelete,
  fieldLabel,
}: { onDelete: () => void; fieldLabel: string } & ModalProps) => {
  return (
    <Modal.Root open={isOpen} onOpenChange={close}>
      <Modal.Content size="small">
        <Modal.Header>
          <Modal.Title>Delete this field?</Modal.Title>
          <Modal.Close />
        </Modal.Header>
        <Modal.Body>
          <div className="t-text-text-60 t-text-body-sm">
            You’re about to remove <b>{fieldLabel}</b> from the list. This
            action cannot be undone. Are you sure you want to proceed?
          </div>
        </Modal.Body>

        <Modal.FooterButtonGroup>
          <Modal.RawClose asChild>
            <Button>Cancel</Button>
          </Modal.RawClose>
          <Button customType="danger" onClick={onDelete}>
            Delete
          </Button>
        </Modal.FooterButtonGroup>
      </Modal.Content>
    </Modal.Root>
  );
};
